import { render, staticRenderFns } from "./noticeByUser.vue?vue&type=template&id=3aa681b5&scoped=true"
import script from "./noticeByUser.vue?vue&type=script&lang=js"
export * from "./noticeByUser.vue?vue&type=script&lang=js"
import style0 from "./noticeByUser.vue?vue&type=style&index=0&id=3aa681b5&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa681b5",
  null
  
)

export default component.exports